import styled, { css } from 'styled-components'

interface CoverageTableProps {
  whiteBackground: boolean
  noPadding?: boolean
  isExpand?: boolean
}

export const SafeAnimalsPackageTableContainer = styled.div`
  width: 1483px;
  margin: 20px 0px;
`

export const Title = styled.h1`
  font-family: Ubuntu;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.02em;
  text-align: left;
`

export const TableContainer = styled.div`
  max-width: 1300px;
  overflow-x: auto;
  box-shadow: 0px 40px 40px 0px #0000001a;
  width: 100%;
  margin: auto;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`

export const Header = styled.th`
  background-color: #0093b2;
  font-family: Ubuntu, sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.05em;
  text-align: start;
  color: #ffffff;
  padding: 10px 40px;
  width: 100%;
`

export const NameHeader = styled(Header)`
  width: 500px;
`

export const ActionsHeader = styled(Header)`
  width: 70px;
  padding: 10px 10px;
`

export const Cell = styled.td`
  font-family: Ubuntu;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.02em;
  max-width: 0;
  // overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
  padding: 10px 40px;
  color: #646464;
  width: auto;

  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .button-link {
    > div {
      margin-left: 0;
    }
  }
`

export const CellNoPadding = styled(Cell)`
  padding: 10px 0;
`

export const NameCell = styled(Cell)``

export const RaceCell = styled(Cell)``

export const RaceCellContainer = styled.div`
  display: flex;
  gap: 10px;
`

export const RaceName = styled.div``

export const RaceEditIcon = styled.img``

export const AnimalName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const NamePackPrice = styled.div`
  font-family: Ubuntu;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #1f1f1f;
`

export const ActionsCell = styled(Cell)`
  width: 70px;

  text-align: start;
  padding: 8px;
  font-weight: 700;
`

export const Row = styled.tr`
  border-bottom: 1px solid #cccccc;
  border-spacing: 0;
  width: 100%;
`

export const RowNoPadding = styled(Row)`
  padding: 10px 0;
`

export const Actions = styled.div`
  display: flex;
  gap: 10px;
`

export const ButtonContainer = styled.span`
  display: flex;
  padding: 2px;
  justify-content: center;
  min-height: 14px;
  width: 22px;
`

export const DeleteButton = styled.img`
  cursor: pointer;
`

export const OpenCollapseButton = styled.img`
  cursor: pointer;
`
export const ExpandedRowContainer = styled.tr`
  margin: 0;
  padding: 0;
  width: 100%;
`

export const ExpandedRow = styled.td`
  width: 100%;

  .full-block-padding {
    display: block;
    width: 100%;
    padding-top: 30px;
  }

  .expanded-row-item {
    display: block;
    width: 100%;
    padding-top: 20px;
  }
`
export const ExtraInfo = styled.tr``

export const ExtraInfoData = styled.td``

export const ExtraInfoText = styled.div`
  margin: 10px auto;
  width: 50%;
  font-family: Ubuntu, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #646464;
`

export const PackageTable = styled.table`
  border-spacing: 0;
  width: 100%;

  .full-width {
    width: 100%;
  }
`

export const PackageTableRow = styled.tr`
  background-color: #d9f0f466;
  border-spacing: 0px;
  padding-top: 20px;
  width: 100%;

  .full-block {
    display: block;
    width: 100%;
  }
`

export const PackageTableTitleRow = styled(PackageTableRow)`
  background-color: #ffffff;
`

export const PackageTableHeader = styled(Header)`
  background-color: #ffffff;
  color: #000000;
  text-align: center;
  padding: 0;
  cursor: pointer;
  width: calc((100% / 6) - 60px);
  position: relative;
  padding-top: 20px;

  *,
  &:after {
    box-sizing: border-box;
  }

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-left: ${({ selected, isRecommended }: any) =>
      selected ? `2px solid ${isRecommended ? '#F39C12' : '#0093b2'}` : 'none'};
    border-right: ${({ selected, isRecommended }: any) =>
      selected ? `2px solid ${isRecommended ? '#F39C12' : '#0093b2'}` : 'none'};
    border-top: ${({ selected, isRecommended }: any) =>
      selected ? `2px solid ${isRecommended ? '#F39C12' : '#0093b2'}` : 'none'};
  }

  .recommended {
    color: #fff;
    background-color: #f39c12;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .wrapper-pack-title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > div {
      width: 24px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .DFcontainer {
        width: 24px;

        .DFradioFieldWrapper {
          width: 24px;
          height: 24px;

          span {
            div {
              width: 24px;

              .DFradioField {
                height: 24px;
                width: 24px;
                position: relative;

                span {
                  top: 0;
                  &::after {
                    top: 8px;
                  }
                }
                label:before {
                  top: 0;
                }

                input[type='radio'] {
                  position: fixed;
                  left: -9999px;
                }
              }
            }
          }
        }
      }
    }

    .pack-title-header {
      width: auto;
      display: block;
      text-align: left;

      > div {
        text-align: left;
      }
    }
  }
`

export const PackageTableNameHeader = styled(PackageTableHeader)`
  max-width: 200px;
  background-color: #ffffff;
`

export const ExpandHeader = styled(PackageTableHeader)`
  min-width: 50px;
  max-width: 50px;
  background-color: #ffffff;
  cursor: initial;
`

export const ExpandTd = styled.td`
  min-width: 50px;
  max-width: 50px;
  cursor: initial;

  .coverage-expand {
    width: 100%;
    text-align: center;
    position: relative;
    z-index: 2;
    padding-top: 5px;
    cursor: pointer;
  }

  ${({ whiteBackground }: CoverageTableProps) =>
    whiteBackground &&
    css`
      background-color: #fff;
    `};
`

export const PackageTableCell = styled.td<CoverageTableProps>`
  padding: 15px 20px;
  text-align: left;
  overflow: hidden;
  font-size: 14px;
  border-spacing: 0px;
  position: relative;

  *,
  &:after {
    box-sizing: border-box;
  }

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    border-left: ${({ border, isRecommended }: any) =>
      border ? `2px solid ${isRecommended ? '#F39C12' : '#0093b2'}` : 'none'};
    border-right: ${({ border, isRecommended }: any) =>
      border ? `2px solid ${isRecommended ? '#F39C12' : '#0093b2'}` : 'none'};
    border-bottom: ${({ border, isRecommended, lastItem }: any) =>
      border && lastItem
        ? `2px solid ${isRecommended ? '#F39C12' : '#0093b2'}`
        : 'none'};
  }

  .rowCoverage {
    display: flex;
    justify-content: flex-end;
    z-index: 2;
    position: relative;
  }

  .rowPack {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .infoCoverage {
    display: flex;
    position: relative;
    justify-content: center;
    z-index: 2;
  }

  .wrapper-table {
    position: relative;
    z-index: 1;
    display: flex;
  }

  ${({ whiteBackground }: CoverageTableProps) =>
    whiteBackground &&
    css`
      background-color: #fff;
    `};
`

export const PackageTableCellCoverage = styled.td<CoverageTableProps>`
  padding: 0 20px 5px;
  text-align: left;
  overflow: hidden;
  font-size: 14px;
  border-spacing: 0px;

  ${({ whiteBackground }: CoverageTableProps) =>
    whiteBackground &&
    css`
      background-color: #fff;
    `};
`

export const PackageTableRowTitleCell = styled(PackageTableCell)`
  text-align: start;
`

export const PackageTableRowTitleCellContainer = styled.div`
  font-family: Ubuntu;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  word-wrap: break-word;
  display: flex;
  justify-content: space-between;
`

export const PackageTableRowTitleCellText = styled.div``

export const PackageTableRowTitleCellOpenCloseIcon = styled.img``

export const PackageTableCellTitle = styled.div`
  margin: 5px 0 0;
  display: flex;
  background-color: #fff;
  position: relative;
  justify-content: space-between;

  .arrow {
    position: absolute;
    right: -16px;
  }
`

export const PackNameHeader = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #646464;
  padding: 0 10px;
`

export const PackPriceHeader = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.02em;
  text-align: right;
  color: #0093b2;
  padding: 0 25px;

  span {
    &.empty {
      min-height: 40px;
      display: block;
    }
  }
`

export const PackOldPriceHeader = styled.div`
  font-family: Ubuntu, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #1f1f1f;
  text-decoration: line-through;
`

export const PackageTableTypeText = styled.div`
  font-weight: 700;
  color: #0093b2;
`

export const PackageTableTypeIcon = styled.img``

export const PackageTableCellCollapsable = styled(PackageTableCell)`
  text-align: end;
`

export const PackageTableCellCollapsableButton = styled.img`
  cursor: pointer;
  right: 0;
`

export const Checkmark = styled.img`
  display: block;
  margin: auto;
`

export const NoCheckmark = styled.img`
  display: block;
  margin: auto;
`

export const ChangeBreeds = styled.div`
  display: flex;
`
export const ChangeBreedsIcon = styled.div`
  cursor: pointer;
  margin-left: 16px;
`

export const CellWrapper = styled.div`
  text-align: center;

  .checkContainer {
    width: 36px;
    height: 46px;
    margin: auto;
    position: relative;

    > div {
      margin: 0 auto;
    }
  }

  .description {
    width: 100%;
    font-size: 11px;
    margin-bottom: 5px;

    &.no-margin-top {
      margin-top: 0;
    }

    .bold {
      font-weight: 700;
    }
  }
`

export const PriceContainer = styled.div`
  position: relative;
  z-index: 2;

  .price {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dropdown {
    padding-left: 16px;
    padding-right: 16px;
  }
`

export const PriceDropDown = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 300;
  width: 100%;
`
